/**
 * Native app bridge — communicates with the React Native / iOS / Android wrapper.
 * Matches the old system's AppCommunication.js protocol.
 */

/** Returns true when running inside the native app WebView. */
export function isNativeApp() {
  return !!(
    window.ReactNativeWebView?.postMessage
    || window.Android?.sendAppMessage
    || window.webkit?.messageHandlers?.ipscAppMessageHandler
  );
}

/** Send a command to the native app. */
export function sendToNativeApp(cmd) {
  const msg = JSON.stringify(cmd);
  if (window.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(msg);
  } else if (window.Android?.sendAppMessage) {
    window.Android.sendAppMessage(msg);
  } else if (window.webkit?.messageHandlers?.ipscAppMessageHandler) {
    window.webkit.messageHandlers.ipscAppMessageHandler.postMessage(msg);
  }
}

/** Request Google sign-in from the native app. */
export function requestGoogleLogin() {
  sendToNativeApp({ src: 'google-login', type: 'on-login' });
}

/** Request Facebook sign-in from the native app. */
export function requestFacebookLogin() {
  sendToNativeApp({ src: 'facebook-login', type: 'on-login' });
}
